import BookByCategory from "./book-by-category.page";

export default BookByCategory;
